import React from "react";
import "./GlobalMap.css";

function GlobalMap() {
  return (
    <div
      id="map-container-google-1"
      class="z-depth-1-half map-container"
      //   style={{ height: "100px" }}
    >
      <iframe
        src="https://maps.google.com/maps?q=kualalumpur&t=&z=13&ie=UTF8&iwloc=&output=embed"
        frameborder="0"
        // style="border:0"
        allowfullscreen
      ></iframe>
    </div>
  );
}

export default GlobalMap;
